;var location = globalThis.location,setTimeout = globalThis.setTimeout,clearTimeout = globalThis.clearTimeout,document = globalThis.document,trustedTypes = globalThis.trustedTypes,self = globalThis.self;
const LOCKDOWN_SHIMS = [];;